import simpleRestProvider from "ra-data-simple-rest";
import { DataProvider, fetchUtils } from "react-admin";
import { PlatformUiEnvToHostMap } from "./platform-ui-env-to-host-map";
import { useContext } from "react";
import { AccessTokenContext } from "../auth/access-token-context";
import { usePlatformUiEnv } from "../env/use-platform-ui-env";
import { PlatformUiEnv } from "../platform-ui-envs.type";
import { AuActiveOrgHeader, OrgDto } from "@arrowsup/platform-dtos";
import { UserContext } from "../auth/user-context";

export const AuDataProviderPathPrefix = `/api/data`;

export const makeAuDataProvider = (
  env: PlatformUiEnv,
  getAccessToken: () => Promise<string>,
  activeOrg?: OrgDto
): DataProvider => {
  const fetchJson: typeof fetchUtils.fetchJson = async (url, options = {}) => {
    const headers = options.headers
      ? new Headers(options.headers)
      : new Headers();

    headers.set("Authorization", "Bearer " + (await getAccessToken()));

    // The active org is validated against the user's memberships server-side.
    if (activeOrg) {
      headers.set(AuActiveOrgHeader, activeOrg.id.toString());
    }

    options.headers = headers;

    return fetchUtils.fetchJson(url, options);
  };

  return simpleRestProvider(
    PlatformUiEnvToHostMap[env] + AuDataProviderPathPrefix,
    fetchJson
  );
};

export const useAuDataProvider = (): DataProvider => {
  const getAccessToken = useContext(AccessTokenContext).getAccessToken;
  const env = usePlatformUiEnv();
  const userContext = useContext(UserContext);

  return makeAuDataProvider(env, getAccessToken, userContext.activeOrg);
};
